export const RESET = 'EXSBPRICETYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBPRICETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPRICETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPRICETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPRICETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPRICETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPRICETYPE_UPDATE_UPDATE_RETRIEVED'
